export const WIX_INSTALL = 'WIX_INSTALL';
